export const deleteServiceInAppt = (appointmentId,serviceId,isSeriesEligible) => { 

    return JSON.stringify({
        query: `mutation ($appointmentId:UUID!,$serviceId:UUID!,$isSeriesEligible:Boolean){
            deleteServiceMutation
        (appointmentId:$appointmentId,serviceId:$serviceId,isSeriesEligible:$isSeriesEligible){
          message
          appointmentId
        }
      }`,
        variables: {"appointmentId": String(appointmentId),"serviceId":String(serviceId), "isSeriesEligible":Boolean(isSeriesEligible)}
      })
    };